import * as React from 'react';
import { Form, HiddenInput, Textarea, CustomSubmitButton, CustomButton, ButtonType } from 'soprasteria-ui-library';
import { IStandardPhrase } from '../../models/IStandardPhrase';
import { useAuth } from '../../App';
import { StandardPhraseApi } from '../../api/StandardPhraseApi';
import { IPage } from '../../models/IPage';

interface IStandardPhraseSelectionForm {
    selectedStandardPhrase?: IStandardPhrase;
    standardPhraseRequestUrl: string;
    getStandardPhrases: (page: IPage) => void;
    changeErrorMessage: (message: string) => void;
    changeSuccessMessage: (message: string) => void;
    setShowStandardPhraseTable: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface IStandardPhraseDecisionConnectionCheckbox {
    label: string;
    name: string;
}

export const StandardPhraseSelectionForm: React.FunctionComponent<IStandardPhraseSelectionForm> = ({ selectedStandardPhrase, standardPhraseRequestUrl, changeErrorMessage, changeSuccessMessage, setShowStandardPhraseTable, getStandardPhrases }) => {

    const auth = useAuth();
    const api = new StandardPhraseApi(auth);
    const [isSavingStandardPhrase, setIsSavingStandardPhrase] = React.useState<boolean>();

    const saveStandardPhrase = (data: IStandardPhrase) => {
        setIsSavingStandardPhrase(true);

        api.saveStandardPhrase(standardPhraseRequestUrl, data, () => {
            setShowStandardPhraseTable(true);
            changeSuccessMessage("Standardfrasen har sparats");
            getStandardPhrases({ pageNumber: 1, pageSize: 10 });
        }, (error) => {
            changeErrorMessage(error);
        }, () => setIsSavingStandardPhrase(false));
    }

    return (
        <Form onSubmit={saveStandardPhrase}>
            <h4>Skapa standardfras</h4>
            <HiddenInput name="standardPhraseId" value={selectedStandardPhrase?.standardPhraseId.toString() ?? "0"} />
            <div className="row">
                <div className="col-12">
                    <Textarea label="Text" name="text" defaultValue={selectedStandardPhrase?.text} required maxLength={1000} rows={10} />
                </div>
                <div className="col-12">
                    <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" onClick={() => setShowStandardPhraseTable(true)} />
                    <CustomSubmitButton isLoading={isSavingStandardPhrase}>Spara standardfras</CustomSubmitButton>
                </div>
            </div>
        </Form>
    )

}